<template>
    <div class="royal-blue lighten-2 pa-5 rounded-lg d-flex align-start" style="border: 1px solid var(--v-royal-blue-lighten1) !important;">
        <div class="d-flex align-center mr-5">
            <icon
                icon="CircleArrowUp"
                color="royal-blue"
            />
            <div class="subtitle-1 royal-blue--text ml-2 text-no-wrap">{{ $t('Elite plan') }}</div>
        </div>
        <div class="body-2 mr-4">
            {{ $t('Customize, automate, analyze and enhance your business management with Uku Elite plan features.') }}
            <a href="/api/help_link/elite_read_more" target="_blank">{{ $t('Read more') }}</a>
        </div>
        <primary-button
            v-if="!isAccountElite(companyId)"
            color="main"
            class="inverted--text"
            @click="onUpgradeBundle">
            {{ $t('Get elite plan') }}
        </primary-button>
    </div>
</template>

<script>
import DialogModule from "../../store/modules/dialog";
import AccountModule from '@/store/modules/account'

export default {
    name: "EliteRow",
    props: {
        companyId: {
            type: Number,
            default: null
        }
    },
    setup(props, ctx) {
        const {closeDialog} = DialogModule();
        const {isAccountElite} = AccountModule()

        const onUpgradeBundle = () => {
            ctx.root._router.push({
                name: "subscription_choose_plan",
                params: {
                    id: props.companyId,
                    set_plan_name: "elite",
                }
            });
            closeDialog()
        };

        return {
            isAccountElite,
            onUpgradeBundle
        }
    }
};
</script>
